import { baseUrl } from '../../network'

export const getOrderUrl = (orderId: number) => baseUrl + `api/orders/${orderId}`
export const singleOrderRefundUrl = (orderId: number) => baseUrl + `api/orders/${orderId}/refund`
export const editOrderUrl  = (orderId: number) => baseUrl + `api/orders/${orderId}`
export const getProviderOfferingsUrl = (relationshipId: number) => baseUrl + `api/provider/${relationshipId}/offerings`
export const companyOfferingsUrl = (companyId: number) => baseUrl + `api/company/${companyId}/offerings`
export const getWarehousesUrl = (companyId: number) => baseUrl + `api/company/${companyId}/warehouses`
export const getCustomerAddressesUrl = (relationshipId: number) => baseUrl + `api/provider/${relationshipId}/addresses`
export const getCustomersUrl = (companyId: number) => baseUrl + `api/company/${companyId}/customers` 